export const MAINTENANCE_MODE_WARNING_STORAGE_KEY =
  'maintenanceModeWarningDismissed';
